import { ScrollArea } from '@mantine/core';
import classes from './ScrollArea.module.css';

export const ScrollAreaConfig = ScrollArea.extend({
  classNames: {
    scrollbar: classes.scrollbar,
    thumb: classes.thumb,
  },
});
